import { defaultsDeep } from 'lodash';

const getPropsLumaLegacy = (theme, defaults) => {
  const {
    custom,
    palette,
    typography,
    spacing: { unit },
    zIndex: { tooltip },
  } = theme;

  const {
    palette: { colorSupportSteel, colorSupportSlate, colorVeryLightGray, colorDanger },
    fontSizes,
  } = custom;
  const {
    secondary,
    primary,
    common: { white },
  } = palette;
  const { fontFamily } = typography;

  return defaultsDeep(
    {},
    {
      themeName: 'Luma Legacy',
      custom,
      palette,
      typography,
      overrides: {
        // https://app.clickup.com/t/fb5gq
        MuiIconButton: {
          colorPrimary: {
            color: colorSupportSlate,
          },
        },
        MuiFormControlLabel: {
          label: {
            color: primary.main,
          },
        },
        MuiIcon: {
          colorPrimary: {
            color: colorSupportSlate,
          },
          fontSizeSmall: {
            fontSize: fontSizes.subHeading,
          },
          fontSizeLarge: {
            fontSize: fontSizes.largeIcon,
          },
        },
        MuiSvgIcon: {
          colorPrimary: {
            color: primary.main,
          },
          fontSizeSmall: {
            fontSize: fontSizes.subHeading,
          },
          fontSizeLarge: {
            fontSize: fontSizes.largeIcon,
          },
        },
        MuiDialogActions: {
          root: {
            padding: 16,
            margin: 0,
            background: colorVeryLightGray,
          },
        },
        MuiFormLabel: {
          asterisk: {
            color: colorDanger,
          },
        },
        // WORKAROUND reverging primary color for icons changed on https://app.clickup.com/t/fb5gq
        LumaIconButton: {
          colorPrimary: {
            color: primary.main,
          },
        },
        MuiButton: {
          root: {
            color: primary.main,
          },
          sizeLarge: {
            fontSize: fontSizes.body,
          },
          containedSecondary: {
            color: white,
            '&$focused': {
              color: secondary.light,
            },
            '&:hover': {
              backgroundColor: secondary.light,
            },
          },
        },
        MuiFormControl: {
          root: {
            marginTop: 17,
          },
        },
        MuiFormHelperText: {
          error: {},
          root: {
            fontFamily,
            fontSize: fontSizes.small,
            fontWeight: 500,
            color: primary.main,
          },
        },
        MuiInput: {
          disabled: {},
          error: {},
          focused: {},
          input: {
            '&::placeholder': {
              color: colorSupportSteel,
              fontSize: fontSizes.bodyG,
              opacity: 1,
            },
            color: primary.main,
            fontFamily,
            fontWeight: 500,
            padding: '6px 0px 6px',
          },
          underline: {
            '&:hover:not($disabled):not($focused):not($error):before': {
              borderBottom: '1px solid #e0e0e0',
            },
            '&:before': {
              borderBottom: '1px solid #e0e0e0',
            },
            '&:after': {
              borderBottom: `2px solid ${primary.main}`,
            },
          },
        },
        MuiInputBase: {
          input: {
            '&.Select.Select--single .Select-control': {
              height: '30px !important',
            },
            '&.Select.has-value.Select--single > .Select-control .Select-value': {
              padding: `${unit * 2}px ${unit * 2}px ${unit * 2}px 0px !important`,
            },
            '&.Select.Select--single > .Select-control .Select-placeholder': {
              padding: `${unit * 2}px ${unit * 2}px ${unit * 2}px 0px !important`,
            },
            '& .Select-input input': {
              padding: '0px !important',
            },
            '& .Select-multi-value-wrapper': {
              padding: `${unit / 2}px ${unit * 5}px ${unit / 2}px 0px !important`,
            },
            '&.Select.Select--single .Select-control > *:last-child': {
              paddingRight: 0,
              paddingTop: unit / 2,
            },
          },
        },
        MuiInputLabel: {
          error: {},
          focused: {},
          formControl: {
            fontFamily,
            fontSize: fontSizes.bodyG,
            fontWeight: 500,
            transform: 'translate(0px, 24px) scale(1)',
          },
          root: {
            color: primary.light,
            fontSize: fontSizes.bodyG,
            fontWeight: 500,
            '&$error': {
              color: primary.light,
            },
            '&$error$focused': {
              color: primary.light,
            },
          },
          shrink: {
            fontSize: fontSizes.bodyG,
            fontWeight: 500,
            '&$focused': {
              color: primary.light,
            },
          },
        },
        MuiInputAdornment: {
          root: {
            color: colorSupportSteel,
          },
        },
        MuiModal: {
          root: {
            zIndex: tooltip,
          },
        },
      },
    },
    defaults,
  );
};

export default getPropsLumaLegacy;
